// Lib
import React from 'react';
import { useDispatch } from 'react-redux';

// Actions
import { navigateToFreePlanUpgrade } from '../../../reducers/navigationActions';

// Components
import StyledButton from '../../buttons/StyledButton';

// Styles
import './FreeFileLimitErrorContent.scss';

type Props = {
    close: () => void;
};

const FreeFileLimitErrorContent: React.FC<Props> = ({ close }) => {
    const dispatch = useDispatch();

    const viewUpgradeOptions = () => {
        close();
        dispatch(navigateToFreePlanUpgrade({ featureHighlight: 'files' }));
    };

    return (
        <div className="FreeFileLimitErrorModal">
            <h1>You&apos;ve reached the free upload limit</h1>
            <p className="description">Free users can upload ten files. Upgrade to the pro plan for unlimited space.</p>
            <StyledButton className="primary" onClickFn={viewUpgradeOptions}>
                Upgrade now
            </StyledButton>
            <img className="file-types-image" src={require('./image/file-upload-limit.png')} />
        </div>
    );
};

export default FreeFileLimitErrorContent;
